import { connect } from 'react-redux'

import ModifyRecurrence from './ModifyRecurrence'
import * as fromEntities from '@src/redux/modules/entities'
import * as fromRecurrence from '@src/redux/modules/recurrence'

const selector = (state, props) => {
  const {
    params: { recurrenceId }
  } = props

  const recurrences = fromEntities.getRecurrences(state)
  const recurrence = recurrences[recurrenceId]

  let aliada
  if (recurrence) {
    const aliadas = fromEntities.getAliadas(state)
    aliada = aliadas[recurrence.aliada]
  }

  return {
    recurrence,
    aliada
  }
}

const actions = {
  fetchRecurrence: fromRecurrence.fetch
}

export default connect(
  selector,
  actions
)(ModifyRecurrence)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/ModifyRecurrence/ModifyRecurrenceContainer.js